import React from 'react';
import { formatCurrency } from 'utils';
import { Stack, Typography } from '@mui/material';
import { BasePrice } from 'modules/equipment/types';

import { QuoteChargeListingEntity } from '../../../../types';
import { quoteChargeCalculator } from '../../../../lib/quoteChargeCalculator';

interface Props {
  field: keyof BasePrice;
  priceCalc: QuoteChargeListingEntity[];
}

export const EquipmentChargeColumnTotalCell = ({ field, priceCalc }: Props) => {
  const total = quoteChargeCalculator.getColumnTotals(priceCalc) as unknown as BasePrice;

  return (
    <Stack>
      <Typography>Total: {formatCurrency(total?.[field] ?? null, true)}</Typography>
    </Stack>
  );
};
